import React from "react";
import VideoPreviewContainer from "./VideoPreviewContainer";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Ajax from "../../../utils/api";
import ajaxRoutes from "../../../utils/ajaxRoutes";

import "./index.scss";
import { Tooltip, Typography } from "antd";
import { decodeString } from "utils";

function VideoPreview({ record, updateFileSelected, updateIsShowingVideoPlayer }) {
	const handleVideoPreviewClick = async () => {
		if (!record?.playback_id) {
			return;
		}
		if (!record.video_url) {
			const videoUrlResponse = await Ajax.call(ajaxRoutes.GET_MUX_VIDEO_URL(record?.playback_id));
			const { url } = videoUrlResponse;
			updateFileSelected(url);
		} else {
			updateFileSelected(record.video_url);
		}

		updateIsShowingVideoPlayer(true);
	};
	const toolTipTitle = !record?.playback_id ? "" : record.duration > 0 ? "Open Video" : "Video is still processing";

	return (
		<div
			style={{ cursor: record.duration > 0 ? "pointer" : null }}
			onClick={record.duration > 0 ? handleVideoPreviewClick : null}
		>
			<Tooltip placement="topLeft" title={toolTipTitle}>
				<Row align="middle" wrap={false}>
					<Col style={{ display: "flex", alignItems: "center" }}>
						<VideoPreviewContainer record={record} />
					</Col>
					<Col>
						<Tooltip placement="right" title={record ? decodeString(record.name) : ""}>
							<Typography.Paragraph ellipsis className="video-preview-title" data-id="lblVideoTitle">
								{record ? decodeString(record.name) : ""}
							</Typography.Paragraph>
						</Tooltip>
					</Col>
				</Row>
			</Tooltip>
		</div>
	);
}

export default VideoPreview;
